//Admin
export const adminURL = '/api/admin/login/';
export const adminReportURL = '/api/admin/download-data';
export const adminChangePasswordURL = '/api/admin/change-password';
export const adminResetPasswordURL = '/api/admin/reset-password-request';
export const adminResetPasswordConfirmURL = '/api/admin/reset-password-confirm';

//Examination
export const examinationURL = '/api/examination/';
export const getExaminationStatusURL = (examinationId: string) =>
  `${examinationURL}${examinationId}/status`;
export const examinationReportURL = (examinationId: string) =>
  `${examinationURL}${examinationId}/report`;
export const examinationResultURL = (examinationId: string) =>
  `${examinationURL}${examinationId}/result`;

//Pretest
const pretestURL = '/api/pre-test';
export const pretestQuestionsURL = `${pretestURL}/questions`;
export const pretestSingleAnswerURL = (examinationID: string) =>
  `${pretestURL}/${examinationID}/answer/`;
export const pretestAllAnswersURL = (examinationID: string) =>
  `${pretestURL}/${examinationID}/submit-all/`;

//MainTest
const maintestURL = '/api/main-test';
export const maintestQuestionsURL = `${maintestURL}/questions`;
export const maintestSingleAnswerURL = (examinationId: string) =>
  `${maintestURL}/${examinationId}/answer/`;
export const maintestAllAnswerURL = (examinationId: string) =>
  `${maintestURL}/${examinationId}/submit-all/`;

//ExternalLinks
export const externalUrlsURL = `/api/external-urls`;
